import koKR from '../../.octopus/ko-KR/index.js';

export default {
  TntdNewReference: koKR,
};
